// Centralized Pusher configuration
import Pusher from "pusher-js";

// Pusher configuration based on backend settings
const pusherConfig = {
    key: "f1d589b7bd3867695a02",
    cluster: "eu",
    forceTLS: true,
    encrypted: true,
    enabledTransports: ["ws", "wss"],
    disabledTransports: [],
    // Add debugging options
    debug: process.env.NODE_ENV === "development",
};

// Create and export Pusher instance
export const createPusherInstance = () => {
    const pusher = new Pusher(pusherConfig.key, {
        cluster: pusherConfig.cluster,
        forceTLS: pusherConfig.forceTLS,
        encrypted: pusherConfig.encrypted,
        enabledTransports: pusherConfig.enabledTransports,
        disabledTransports: pusherConfig.disabledTransports,
    });

    // Add connection event listeners for debugging
    if (pusherConfig.debug) {
        pusher.connection.bind("connecting", () => {
            console.log("🔌 Pusher connecting...");
        });

        pusher.connection.bind("connected", () => {
            console.log("✅ Pusher connected successfully");
        });

        pusher.connection.bind("disconnected", () => {
            console.log("❌ Pusher disconnected");
        });

        pusher.connection.bind("error", (error) => {
            console.error("❌ Pusher connection error:", error);
        });
    }

    return pusher;
};

// Helper function to subscribe to queue updates
export const subscribeToQueueUpdates = (pusher, onUpdate) => {
    const channel = pusher.subscribe("queues");

    // Add subscription event listeners
    channel.bind("pusher:subscription_succeeded", () => {
        console.log("✅ Successfully subscribed to 'queues' channel");
    });

    channel.bind("pusher:subscription_error", (error) => {
        console.error("❌ Subscription error:", error);
    });

    // Listen for queue updates
    channel.bind("queue.updated", (data) => {
        if (onUpdate) {
            onUpdate(data);
        }
    });

    return channel;
};

export default pusherConfig;
